import { Injectable } from '@angular/core';
import { AuthorizationResponseDto } from '../dtos/authorization-response.dto';
import { AuthorizationEntity } from '../../domain/entities/authorization.entity';

/**
 * Mapper for authorization data.
 * Converts between DTOs and domain entities.
 */
@Injectable({ providedIn: 'root' })
export class AuthorizationMapper {
  /**
   * Maps API response DTO to domain entity.
   * @param dto - authorization response DTO
   * @returns authorization domain entity
   */
  toDomain(dto: AuthorizationResponseDto): AuthorizationEntity {
    return {
      role: dto.role as string | null,
      roleName: dto.roleName ?? null,
      dashboardViewTypeName: dto.dashboardViewTypeName ?? null,
      permissions: dto.permissions as string[]
    };
  }
}
